const styles = {
  "app-table": "_app-table_ing3a_1",
  "app-thead": "_app-thead_ing3a_6",
  "app-tr": "_app-tr_ing3a_6",
  "app-th": "_app-th_ing3a_6",
  "app-tbody": "_app-tbody_ing3a_13",
  "app-td": "_app-td_ing3a_13",
  "table-default": "_table-default_ing3a_21",
  "table-divider": "_table-divider_ing3a_25",
  "table-bordered": "_table-bordered_ing3a_33",
  "table-hover": "_table-hover_ing3a_46",
  "no-hover": "_no-hover_ing3a_46"
};
export {
  styles as default
};
//# sourceMappingURL=Table.module.scss.js.map
